export enum Statuses {
  DRAFT = 1,
  PUBLISHED = 2,
}

export enum Stages {
  NEW = 1,
  COMPLETED = 2,
  ARCHIVED = 3,
}
